// @flow
import React, { useEffect, useState } from "react"
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';
import { FacebookShareButton } from "react-share";
import {
    closeVideoCall,
    showHideCustomModal,
    showHideModeratorDisconnect,
    showHideMultiModeratorDisconnect,
    showToastPopup,
    stopRecording,
    setStemRecordingUrl,
    setStemRecording,
    setRecording
} from "../../redux/tool-webjam/actions";
import { Constant, CURRENT_ROOM_LOCATION, CURRENT_ROOM_NAME } from "../../../webjam/constant";
import axios from "axios";
import { socketEmit, socketOn } from "../../../../../socket/index";
import { dispatch, getBaseConfig, getStore, _ValidateIPaddress } from "../../Utils"
import { FEATURE_CUSTOM_REDUX, FEATURE_CUSTOM_REDUX_V2, FEATURE_CUSTOM_REDUX_V3 } from "../../constant";
import { PARTICIPANT_ROLE } from "../../../base/participants";
import Loader from 'react-loader';
import Downloader from "./FileDownloader"
import { messages } from '../../welcome-dashboard/messages';
import { Translate } from '../../../webjam/language';
import close from '../../img/close.png';
import { useSelector } from "react-redux";
import { usePrevious } from "../../welcome-dashboard/Utils";
import { copyText } from "../../../base/util/copyText.web";
import toast from "react-simple-toasts";
import ModalHandler from "./../ModalHandler.js"
import { JitsiRecordingConstants } from "../../../base/lib-jitsi-meet";
import { setUserHangupStatus } from "../../redux/tool-webjam-v3/actions";
import { ct } from "../../constant-Utils";
import Dialog from "../../../base/ui/components/web/Dialog";
import { PushSpinner } from "../components/PushSpinner";


declare var APP: Object;


// main
// {recordingStopped && this.renderModal()}
export const StopRecordingConference = (props) => {
    const { roomorIpAddress } = getStore(FEATURE_CUSTOM_REDUX);
    const { stemRecording, stemRecordingUrl, recordingStopped } = useSelector((state) => state[FEATURE_CUSTOM_REDUX]);
    const { defaultRecordingType } = useSelector((state) => state[FEATURE_CUSTOM_REDUX_V2]);
    const { role } = getStore("features/base/participants").local;
    const [recordingUrl, setRecordingUrl] = useState('');
    const [fbUrl, setFbUrl] = useState('');
    const [cpUrl, setcpUrl] = useState('');
    const [downloadUrl, setDownloadUrl] = useState('');
    const [willWait, setWillWait] = useState(false);
    const [willShow, setWillShow] = useState(false);
    const [_recordingList, _setRecordingList] = useState('');
    const [_recordingListShow, _setRecordingListShow] = useState(false);
    const [stemEnabled, setStemEnabled] = useState(false);
    const [stemEnabledUrl, setStemEnabledUrl] = useState('');
    const kot = getBaseConfig("FbPostUrl");
    const PostUrl = getBaseConfig("PostUrl");
    const [isRegionChina, setIsRegionChina] = useState(false);

    // const kot = `${Constant.App.FbPostUrl}`;
    // const PostUrl = `${Constant.App.PostUrl}`;
    // let roomName = roomorIpAddress;
    // if (_ValidateIPaddress(roomorIpAddress)) {
    //     roomName = roomName.replace(/\./g, "-");
    // }
    // useEffect(() => {
    //     if (recordingStopped) {
    //         if (role == PARTICIPANT_ROLE.MODERATOR) {
    //             if (defaultRecordingType == "JIBRI") {
    //                 // let recName = recIpAddress + "_" + recTimeStamp + ".mp4";
    //                 // const url = Constant.App.JibriRecordingUrl + "/" + authOrganization.name + "/recordings/" + recName;
    //                 let recName = recIpAddress;
    //                 let _recName = recName.replace(/-/g, '.');
    //                 if (_ValidateIPaddress(_recName)) {
    //                     recName = _recName
    //                 }
    //                 recName += "_" + recTimeStamp + ".mp4";
    //                 const url = getBaseConfig("recordingUrl") + "/" + authOrganization.name + "/recordings/" + recName;
    //                 // console.log("recording name ",url)
    //                 setRecordingUrl(url);
    //                 setcpUrl(url);
    //                 let fbShareUrl = kot + "/" + authOrganization.name + "/recordings" + "?name=" + recName;
    //                 // console.log("fb share url ",fbShareUrl)
    //                 setFbUrl(fbShareUrl);
    //             }
    //             var _allStore = getStore(FEATURE_CUSTOM_REDUX);
    //             if (_allStore.stemRecording == true) {
    //                 if (_allStore.stemRecording && _allStore.stemRecordingUrl == '') {
    //                     // setWillWait(true);
    //                     dispatch(showToastPopup({ toastModal: true, modalText: Translate.messages.stemWaiting }));
    //                     setWillShow(false);
    //                 } else {
    //                     setWillWait(true);
    //                     setWillShow(true);
    //                     // Toast(messages.preparingToRecord);
    //                 }
    //             } else {
    //                 // Toast(messages.preparingToRecord);
    //                 setWillWait(true);
    //                 setWillShow(true);
    //             }
    //         }
    //     } else {
    //         setWillWait(false);
    //     }
    // }, [recordingStopped]);

    useEffect(() => {
        if (recordingStopped && role == PARTICIPANT_ROLE.MODERATOR) {
            console.log("jitter 1")
            setWillWait(true);
        }
    }, [recordingStopped])

    const prevStem = usePrevious(stemRecording)
    const prevStemUrl = usePrevious(stemRecordingUrl)

    useEffect(() => {
        if (prevStem != stemRecording) {
            setStemEnabled(stemRecording);
        }

        if (prevStemUrl != stemRecordingUrl) {
            if (stemRecordingUrl) {
                setWillShow(true);
                setStemEnabledUrl(stemRecordingUrl)
                dispatch(showToastPopup({ toastModal: false, modalText: '' }));
            }
        }
    }, [stemRecording, stemRecordingUrl])

    useEffect(async () => {
        socketOn("recording_complete_return", (data) => {
            if (defaultRecordingType != "JIBRI") {
                let roomName = roomorIpAddress;
                let confereneName = '';
                if (roomName) {
                    roomName = roomName.replace(/\./g, "-")
                }

                if (_ValidateIPaddress(roomName)) {
                    confereneName = roomName;
                } else {
                    confereneName = roomorIpAddress;
                }

                let _role = getStore("features/base/participants").local?.role;
                let id = getStore("features/base/participants").local?.id;

                // data.users.push(id)
                if (_role == PARTICIPANT_ROLE.MODERATOR) {
                    if (data.users.indexOf(id) != -1) {
                        let newName = data.recordingName; //FOR recordingUrl

                        let recordingName = data.recordingName;
                        if (recordingName) {
                            if (recordingName.indexOf(".mp4") == -1) {
                                recordingName = kot + "?name=" + recordingName + ".mp4";
                            }
                        }
                        let recordingUrl = data.recordingUrl;
                        if (recordingUrl) {
                            // if (recordingUrl.indexOf("https") == -1 && recordingUrl.indexOf("s3://" + Constant.App.s3RecordingUrl) != -1) {
                            //     recordingUrl = "https://" + Constant.App.s3RecordingUrl + ".s3.amazonaws.com/" + newName + ".mp4";
                            if (recordingUrl.indexOf("https") == -1 && recordingUrl.indexOf("s3://" + getBaseConfig("s3RecordingUrlStaging")) != -1) {
                                recordingUrl = getBaseConfig("recordingUrl") + "/" + newName + ".mp4";
                            }
                        }
                        //FOR recordingUrl
                        setcpUrl(recordingUrl);
                        setRecordingUrl(recordingUrl);

                        //setcpUrl(data.recordingUrl);
                        //setRecordingUrl(data.recordingUrl);
                        setFbUrl(recordingName);
                        setWillWait(false);

                        var allStore = getStore(FEATURE_CUSTOM_REDUX);

                        if (allStore.stemRecording && allStore.stemRecordingUrl == '') {
                            // Show jitsi recording after 20 sec if jamulus/stem recording url is not received
                            // setTimeout(function () {
                            //     dispatch(showToastPopup({ toastModal: false, modalText: '' }));
                            //     setWillShow(true);
                            // }, 40000)

                            // setWillShow(false);

                            dispatch(showToastPopup({ toastModal: true, modalText: ct("Translate.messages.stemWaiting") }));

                        } else {
                            setWillShow(true);
                        }
                        dispatch(stopRecording({
                            recordingStopped: true
                        }));
                    }
                }
            }
        });

        socketOn("recording_popup_display", (data) => {
            var _store_1 = getStore(FEATURE_CUSTOM_REDUX);
            var _store_2 = getStore(FEATURE_CUSTOM_REDUX_V2);
            const userDetail = getStore("features/base/participants").local;
            let localRoom = CURRENT_ROOM_NAME;
            // if (localRoom) {
            //     localRoom = localRoom.substring(1);
            // }

            if (
                (data.roomName == roomorIpAddress || data.roomName == localRoom) &&
                data.recordingName &&
                (data.domain == _store_2.authOrganization.domain || data.domain == CURRENT_ROOM_LOCATION)
            ) {
                if (userDetail.role == PARTICIPANT_ROLE.MODERATOR && _store_2.defaultRecordingType == "JIBRI") {

                    // let recName = _store_1.recIpAddress;
                    // let _recName = recName.replace(/-/g, '.');
                    // if (_ValidateIPaddress(_recName)) {
                    //     recName = _recName
                    // }
                    // recName += "_" + _store_1.recTimeStamp + ".mp4";

                    let recName = data.recordingName;
                    const url = getBaseConfig("recordingUrl") + "/" + _store_2.authOrganization.name + "/recordings/" + recName;
                    setRecordingUrl(url);
                    setcpUrl(url);
                    let fbShareUrl = kot + "/" + _store_2.authOrganization.name + "/recordings" + "?name=" + recName;
                    setFbUrl(fbShareUrl);
                }

                var _allStore = getStore(FEATURE_CUSTOM_REDUX);
                if (_allStore.stemRecording == true) {
                    if (_allStore.stemRecording && _allStore.stemRecordingUrl == '') {
                        if (userDetail.role == PARTICIPANT_ROLE.MODERATOR) {
                            dispatch(showToastPopup({ toastModal: true, modalText: ct("Translate.messages.stemWaiting") }));
                        }
                        setWillShow(false);
                    } else {
                        setWillWait(true);
                        setWillShow(true);
                    }
                } else {
                    if (userDetail.role == PARTICIPANT_ROLE.MODERATOR) {
                        setWillWait(true);
                    }
                    setWillShow(true);
                }
            }
        });

        const { isChinaRegion } = getStore(FEATURE_CUSTOM_REDUX_V3);
        setIsRegionChina(isChinaRegion);
    }, []);


    const stopRecordingFn = () => {
        const store = getStore(FEATURE_CUSTOM_REDUX);
        if (store.stemRecording && store.stemRecordingUrl == "") {

        } else {
            dispatch(setStemRecordingUrl(""))
            dispatch(setStemRecording(false))
            setStemEnabledUrl("")
            setStemEnabled(false)
            setRecordingUrl('');
        }

        if (store.stemRecordingUrl && store.stemRecordingUrl != "" && store.stemRecording) {
            dispatch(setStemRecordingUrl(""))
            dispatch(setStemRecording(false))
        }

        dispatch(setRecording({
            recordingStarted: null // set flag for current user which is started the recording
        }));
        setWillShow(false)
        dispatch(stopRecording({
            recordingStopped: false
        }));
        _setRecordingList([])
        _setRecordingListShow(false)
        setWillWait(false);
    }

    const copyUrl = (cpUrl) => {
        copyText(cpUrl)
        toast(ct("rta-trmc.dashboard.myRecording.recordingLink"), Constant.App.ToastTime.LongCloseTime)
        // window.navigator.clipboard.writeText(cpUrl);
        // alert("Recording url copied");
        // stopRecordingFn();
    }

    const startDownload = () => {
        // DOWNLOAD RECORDING
        // let fileName = `${recIpAddress}_${recTimeStamp}.mp4`;
        // let downloadUrl = `${Constant.App.DownloadVDOUrl}/${fileName}`;
        setTimeout(() => {
            let element = document.createElement('a');
            element.setAttribute('href', recordingUrl);
            element.setAttribute('download', recordingUrl);
            element.setAttribute('target', '_blank');
            element.click();
            //document.body.appendChild(element);
            //document.body.removeChild(element);
        }, 1000);
    }

    const yesDownload = () => {
        // setWillShow(false)
        // TRIGGER DOWNLOAD FUNCTION
        // startDownload();                                                                                                                                                                                                                                                                                                                                                                                                                     
        _setRecordingListShow(true)

        let _final = [{
            name: CURRENT_ROOM_NAME,
            file: recordingUrl,
            filename: CURRENT_ROOM_NAME + ".mp4",
        }]

        if (_recordingList) {
            _final = _recordingList.concat(_final)
        }
        _setRecordingList(_final)
    }

    const downloadStemRecording = () => {
        _setRecordingListShow(true)
        let final = [{
            name: CURRENT_ROOM_NAME + " individual tracks recording",
            file: stemEnabledUrl,
            filename: stemEnabledUrl.split("/").pop(),
        }];

        if (_recordingList) {
            final = _recordingList.concat(final)
        }
        _setRecordingList(final)
    }

    const hideRecording = (status) => {
        _setRecordingListShow(false)
        _setRecordingList([])

    }



    // DOWNLOAD RECORDING
    // let fileName = `${recIpAddress}_${recTimeStamp}.mp4`;
    // let fbUrl = `${Constant.App.FbPostUrl}?name=${fileName}`;
    // let kot = `https://realtimeaudio.com`;
    //const confirmMsg = messages.confirmShareonFB;
    let chkUrl = kot + "925b8cc0-5ef2-4782-abd6-8381d3d9e96e" + ".mp4";
    let userRole = getStore("features/base/participants").local?.role;

    if (userRole != PARTICIPANT_ROLE.MODERATOR) {
        return null;
    } else {
        // if (recordingStopped != undefined && recordingStopped == false) { return null; }
        return (
            <>
                {
                    !recordingUrl && willWait &&
                    <>
                        {getBaseConfig("showPushSpinnerLoader") ?
                            <div className="loader-text-container">
                                <div className='loader-wrapper'>
                                    <PushSpinner
                                        size={30}
                                        color="white"
                                        loading={true}
                                        className={"loader-text-main"}
                                    />
                                </div>
                            </div>
                            :
                            <Loader
                                loaded={false}
                                options={{
                                    color: "#fff"
                                }}
                            > </Loader>
                        }
                    </>
                }

                {
                    willShow && recordingUrl &&
                    //recordingUrl &&
                    // <ModalTransition>
                    //     <div className="host-popup">
                    //         <Modal onClose={stopRecordingFn} shouldCloseOnOverlayClick={false}  >
                    <Dialog
                        disableAutoHideOnSubmit={true}
                        disableBackdropClose={true}
                        hideCloseButton={true}
                        onCancel={() => stopRecordingFn(false)}
                        cancel={{ hidden: true }}
                        ok={{ hidden: true }}
                        testId="download-recording"
                        zIndex={999}
                        rtaClassName="download-recording-modal-wrapper"
                    >
                        <div className="end-session">
                            <div className="titleHelpModal fb-modal-outer">{ct("messages.confirmShareonFB", "messages")}
                                {/* SET FB view here */}
                                {fbUrl && !isRegionChina &&
                                    <FacebookShareButton
                                        url={fbUrl}
                                        quote={PostUrl}
                                        // description="RTA video link here"
                                        // hashtag="#RTA recording">
                                        description={getBaseConfig("name") + " " + ct("rta-trmc.conference.videoLinkHere")}
                                        hashtag={"#" + getBaseConfig("name")}>
                                        {/* <img src={fbb} onClick={this.onCloseModal}/> */}
                                        <><span className="st-btn fb-btn mx-0 mt-4 d-flex justify-content-between align-items-center w-100 facebook-share-btn" >
                                            <span>{ct("rta-trmc.downloadRecording.shareOnFB")}</span>
                                            <i className="fa fa-facebook-official big" aria-hidden="true"></i>

                                        </span></>
                                        {/* <span>Share with <FacebookIcon logofillcolor="white" round size={30} /> </span> */}
                                    </FacebookShareButton>
                                }

                                <button className="st-btn mx-0 my-4 d-flex justify-content-between align-items-center w-100" onClick={yesDownload}>
                                    <span>{ct("rta-trmc.downloadRecording.downloadRecording")}</span>
                                    <i className="fa fa-cloud-download big" aria-hidden="true"></i>
                                </button>

                                <button id="copy_url" className="st-btn d-flex justify-content-between align-items-center w-100" onClick={() => copyUrl(cpUrl)}>
                                    <span className="text-1">{ct("rta-trmc.downloadRecording.copyLink")}</span>
                                    <span className="copy-button-content text-2">{cpUrl}</span>
                                    <i className="fa fa-clone big" aria-hidden="true"></i>
                                </button>
                                {
                                    stemEnabledUrl &&
                                    <button className="st-btn mx-0 my-4 d-flex justify-content-between align-items-center w-100" onClick={downloadStemRecording}>
                                        <span>{ct("rta-trmc.downloadRecording.trackRecording")}</span>
                                        <i className="fa fa-cloud-download big" aria-hidden="true"></i>
                                    </button>
                                }
                            </div>
                            <div className="footer-bottom">
                                <button id="close-recording-modal" className="no-host-btn h30" onClick={stopRecordingFn}>
                                    <span>{ct("rta-trmc.downloadRecording.close")}</span>
                                </button>
                            </div>
                        </div>
                    </Dialog>
                    //         {/* </Modal>
                    //     </div>
                    // </ModalTransition> */}
                }

                {_recordingListShow &&
                    <Downloader
                        files={_recordingList}
                        hideRecording={hideRecording}
                    />
                }
            </>)
    }
}

// {showModalError && this.renderHelpModal()}
export const disconnectRoom = (props) => {
    const { hostData, userLoginData, usersData } = getStore(FEATURE_CUSTOM_REDUX);

    const _closeHelpModal = () => {
        dispatch(showHideCustomModal({ showModalError: false }));
    }

    const successHostModal = () => {
        dispatch(setUserHangupStatus("leave"))
        dispatch(showHideCustomModal({ showModalError: false }));
        dispatch(closeVideoCall({ closeVideo: true }));
    }

    return (
        <ModalTransition>
            <div className="host-popup">
                <Modal onClose={_closeHelpModal}
                    testId={'disconnect-host'}>
                    <div className="end-session">
                        {hostData ?
                            <div className="titleHelpModal">{hostData.disconnectBtnMsg}</div>
                            :
                            <div className="titleHelpModal">{userLoginData?.isAdmin && !usersData?.isHost ? ct("messages.confirmDisconnectRoomOwner", "messages") : ct("messages.confirmDisconnectRoom", "messages")}</div>
                        }
                        <div className="footer-bottom">
                            <button className="yes-host-btn" onClick={successHostModal}>{ct("Translate.buttonTitle.yesSmall")}</button>
                            <button className="no-host-btn" onClick={_closeHelpModal}>{ct("Translate.buttonTitle.noSmall")}</button>
                        </div>
                    </div>
                </Modal>
            </div>
        </ModalTransition>)
}

export const DisconnectModerator = (props) => {
    const { roomorIpAddress } = getStore(FEATURE_CUSTOM_REDUX);
    const { authOrganization } = getStore(FEATURE_CUSTOM_REDUX_V2);
    const { hostData } = getStore(FEATURE_CUSTOM_REDUX);
    let _isRecordingRunning = useSelector(state => state['features/recording'].sessionDatas.find(e => e.mode == JitsiRecordingConstants.mode.FILE
        && (e.status === JitsiRecordingConstants.status.ON || e.status === JitsiRecordingConstants.status.PENDING)))

    let _isStreamingRunning = useSelector(state => state['features/recording'].sessionDatas.find(e => e.mode == JitsiRecordingConstants.mode.STREAM
        && (e.status === JitsiRecordingConstants.status.ON || e.status === JitsiRecordingConstants.status.PENDING)))


    const _closeHelpModal = () => {
        dispatch(showHideModeratorDisconnect({ showModeratorModal: false }));
    }

    const successHostModal = () => {
        dispatch(showHideModeratorDisconnect({ showModeratorModal: false }));
        dispatch(closeVideoCall({ closeVideo: true }));
    }

    const endRoomHostModal = () => {
        dispatch(setUserHangupStatus("end"))
        dispatch(showHideModeratorDisconnect({ showModeratorModal: false }));
        dispatch(closeVideoCall({ closeVideo: true }));
        // END Meeting RIGHTS GRANTED
        socketEmit("end_meeting_for_all", { roomName: roomorIpAddress, organization_id: authOrganization._id });
    }

    return (
        <>
            {!_isRecordingRunning && !_isStreamingRunning &&
                <ModalTransition>
                    <div className="host-popup">
                        <Modal onClose={_closeHelpModal}>
                            <div className="end-session">
                                {hostData ?
                                    <div className="titleHelpModal">{hostData.disconnectBtnMsg}</div>
                                    :
                                    <div className="titleHelpModal">{ct("messages.confirmSingleModDisconnect", "messages")}</div>
                                }
                                <div className="footer-bottom">
                                    <button className="yes-host-btn" onClick={endRoomHostModal}>{ct("rta-trmc.hangUp.endBtn")}</button>
                                    <button className="no-host-btn" onClick={_closeHelpModal}>{ct("Translate.buttonTitle.cancelSmall")}</button>
                                </div>
                            </div>
                        </Modal>
                    </div>
                </ModalTransition>
            }
        </>
    )
}

export const DisconnectMultiModerator = (props) => {
    const { hostData } = getStore(FEATURE_CUSTOM_REDUX);
    const { authOrganization } = getStore(FEATURE_CUSTOM_REDUX_V2);
    let _isRecordingRunning = useSelector(state => state['features/recording'].sessionDatas.find(e => e.mode == JitsiRecordingConstants.mode.FILE
        && (e.status === JitsiRecordingConstants.status.ON || e.status === JitsiRecordingConstants.status.PENDING)))

    let _isStreamingRunning = useSelector(state => state['features/recording'].sessionDatas.find(e => e.mode == JitsiRecordingConstants.mode.STREAM
        && (e.status === JitsiRecordingConstants.status.ON || e.status === JitsiRecordingConstants.status.PENDING)))

    const _closeHelpModal = () => {
        dispatch(showHideMultiModeratorDisconnect({ showMultiModeratorModal: false }));
    }

    const successHostModal = () => {
        dispatch(showHideMultiModeratorDisconnect({ showMultiModeratorModal: false }));
        dispatch(closeVideoCall({ closeVideo: true }));
    }

    const endRoomHostModal = () => {
        dispatch(showHideMultiModeratorDisconnect({ showMultiModeratorModal: false }));
        dispatch(closeVideoCall({ closeVideo: true }));
        // END Meeting RIGHTS GRANTED
        socketEmit("end_meeting_for_all", { organization_id: authOrganization._id });
    }

    return (
        <>
            {!_isRecordingRunning && !_isStreamingRunning &&
                <ModalTransition>
                    <div className="host-popup">
                        <Modal onClose={_closeHelpModal}>
                            <div className="end-session">
                                {hostData ?
                                    <div className="titleHelpModal">{hostData.disconnectBtnMsg}</div>
                                    :
                                    <div className="titleHelpModal">{ct("messages.confirmMultiModDisconnect", "messages")}</div>
                                }
                                <div className="footer-bottom">
                                    <button className="yes-host-btn" onClick={endRoomHostModal}>{ct("rta-trmc.hangUp.endBtn")}</button>
                                    <button className="yes-host-btn" onClick={successHostModal}>{ct("rta-trmc.hangUp.leaveBtn")}</button>
                                    <button className="no-host-btn" onClick={_closeHelpModal}>{ct("Translate.buttonTitle.cancelSmall")}</button>
                                </div>
                            </div>
                        </Modal>
                    </div>
                </ModalTransition>
            }
        </>
    )
}

export const toggletoastModal = (props) => {
    let { modalText, toastSubmitFunction, toastCancelFunction, toastAutoSubmit, toastLeaveFunction } = getStore(FEATURE_CUSTOM_REDUX);
    let html = <></>;
    if (modalText.indexOf("<br/>") != -1) {
        modalText = modalText.split("<br/>");
        html = <>{modalText[0]}<br /><br />{modalText[1]}</>
        if (getBaseConfig("deeplinking") == false) {
            html = <>{modalText[0]}</>
        }
    }

    else if (modalText.indexOf("<a href") != -1) {
        // modalText = modalText.split("ExternalLink:");
        html = <span dangerouslySetInnerHTML={{ __html: modalText }}></span>
    } else {
        html = <>{modalText}</>
    }

    const _closeHelpModal = () => {
        dispatch(showToastPopup({ toastModal: false, modalText: '' }));
    }

    const modalActionButtons = (toastSubmitFunction, toastCancelFunction, toastAutoSubmit, toastLeaveFunction) => {
        let returnData = [];

        let ModalHandlerInst = ModalHandler;
        if (toastSubmitFunction == 'continueStreaming') {
            if (ModalHandlerInst.hasOwnProperty("continueStreaming")) {
                returnData.push(<button className="submit-button join-meeting-pass continue-btn"
                    onClick={() => ModalHandlerInst[toastSubmitFunction]()}
                >{ct("rta-trmc.hangUp.continueStreaming")}</button>)
            }
        } else if (toastSubmitFunction == 'continueRecording') {
            if (ModalHandlerInst.hasOwnProperty("continueRecording")) {
                returnData.push(<button className="submit-button join-meeting-pass continue-btn"
                    onClick={() => ModalHandlerInst[toastSubmitFunction]()}
                >{ct("rta-trmc.hangUp.continueRecording")}</button>)
            }
        }

        if (toastCancelFunction == 'stopStreaming') {
            if (ModalHandlerInst.hasOwnProperty("stopStreaming")) {
                returnData.push(<button className="cancel-button stop-btn"
                    onClick={() => ModalHandlerInst[toastCancelFunction]()}
                >{ct("rta-trmc.hangUp.stopStreaming")}</button>)
            }
        } else if (toastCancelFunction == 'stopRecording') {
            if (ModalHandlerInst.hasOwnProperty("stopRecording")) {
                returnData.push(<button className="cancel-button stop-btn"
                    onClick={() => ModalHandlerInst[toastCancelFunction]()}
                >{ct("rta-trmc.toolBox.stopRecording")}</button>)
            }
        }

        if (toastAutoSubmit) {
            if (ModalHandlerInst.hasOwnProperty("autoStopRecording")) {
                ModalHandlerInst[toastAutoSubmit]()
            }

        }

        // Static for Hang Up button
        if (toastLeaveFunction == 'leaveStopStreaming') {
            if (ModalHandlerInst.hasOwnProperty("continueStreaming")) {
                returnData.push(<button className="submit-button join-meeting-pass continue-btn-hang"
                    onClick={() => ModalHandlerInst["continueStreaming"]()}
                >{ct("rta-trmc.hangUp.continueStreaming")}</button>)
            }
            if (ModalHandlerInst.hasOwnProperty("leaveStopStreaming")) {
                returnData.push(<button className="submit-button join-meeting-pass leave-btn"
                    onClick={() => ModalHandlerInst["leaveStopStreaming"]()}
                >{ct("rta-trmc.hangUp.laveWithoutStopping")}</button>)
            }
            if (ModalHandlerInst.hasOwnProperty("stopStreaming")) {
                returnData.push(<button className="cancel-button stop-btn-hang"
                    onClick={() => ModalHandlerInst["stopStreaming"]()}
                >{ct("rta-trmc.hangUp.stopStreaming")}</button>)
            }
        } else if (toastLeaveFunction == 'leaveStopRecording') {
            if (ModalHandlerInst.hasOwnProperty("continueRecording")) {
                returnData.push(<button className="submit-button join-meeting-pass continue-btn-hang"
                    onClick={() => ModalHandlerInst["continueRecording"]()}
                >{ct("rta-trmc.hangUp.continueRecording")}</button>)
            }
            if (ModalHandlerInst.hasOwnProperty("leaveStopRecording")) {
                returnData.push(<button className="submit-button join-meeting-pass leave-btn"
                    onClick={() => ModalHandlerInst["leaveStopRecording"]()}
                >{ct("rta-trmc.hangUp.leaveWithoutStopping")}</button>)
            }
            if (ModalHandlerInst.hasOwnProperty("stopRecording")) {
                returnData.push(<button className="cancel-button stop-btn-hang"
                    onClick={() => ModalHandlerInst["stopRecording"]()}
                >{ct("rta-trmc.toolBox.stopRecording")}</button>)
            }
        }
        return returnData
    }

    return <Dialog
        disableAutoHideOnSubmit={true}
        disableBackdropClose={true}
        hideCloseButton={false}
        onCancel={() => _closeHelpModal()}
        cancel={{ hidden: true }}
        ok={{ hidden: true }}
        testId="common-pop-dialog"
        zIndex={999}
        rtaClassName="common-dialog"
        showHeader={false}
    >
        <div className="webjam-popup-session">
            {/* <div className="titleHelpModal">{Translate.messages.webJamConnected}</div> */}
            <div className="titleHelpModal">{html}</div>
            <div className="dialog-btn-wrapper">
                {modalActionButtons(toastSubmitFunction, toastCancelFunction, toastAutoSubmit, toastLeaveFunction)}
            </div>
        </div>
    </Dialog>

    // return (
    //     <ModalTransition>
    //         <div className="webjam-popup">
    //             <Modal onClose={_closeHelpModal}
    //                 testId={"common-pop-modal"}
    //             >
    //                 <span className="webjam-popup close">
    //                     <img src={close} id="close-toast-modal" onClick={_closeHelpModal} />
    //                 </span>
    //                 <div className="webjam-popup-session">
    //                     {/* <div className="titleHelpModal">{Translate.messages.webJamConnected}</div> */}
    //                     <div className="titleHelpModal">{html}</div>
    //                     {modalActionButtons(toastSubmitFunction, toastCancelFunction, toastAutoSubmit, toastLeaveFunction)}
    //                 </div>
    //             </Modal>
    //         </div>
    //     </ModalTransition>)
}

export const stopStreamingfn = (props) => {
    let { usersData } = getStore(FEATURE_CUSTOM_REDUX);
    if (usersData) {
        let url = `${Constant.App.StreamingUrl}/stop-streaming`;
        axios.get(url).then(response => {
            console.log(" STOP STREAM :::::::::::: ", response);
        }).catch(error => {
            console.log("Invalid STOP streaming :", error);
        });
    }
}

export const startRecordingRequest = (mp4name) => {
    const { roomorIpAddress } = getStore(FEATURE_CUSTOM_REDUX);
    let isIp = _ValidateIPaddress(roomorIpAddress);
    let url;
    let noChangedRoomName = getBaseConfig('noChangedRoomName')
    if (noChangedRoomName == true) {
        recIpAddressNew = roomorIpAddress
        isIp = _ValidateIPaddress(roomorIpAddress);
        url = Constant.App.ServerUrl + '/start-audio-route?isIP=' + isIp + '&roomname=' + roomorIpAddress + '&server=' + getBaseConfig("serverVarRecordingStreaming") + `&mp4name=${mp4name}` + `&visibleRoom=${CURRENT_ROOM_NAME}`;
    } else {
        url = Constant.App.ServerUrl + '/start-audio-route?isIP=' + isIp + '&roomname=' + roomorIpAddress + '&server=' + getBaseConfig("serverVarRecordingStreaming") + `&mp4name=${mp4name}`;
    }
    return axios.get(url);
    // axios.get(url).then(response => {
    //     console.log(":::::::::::::::::: without device ", response);
    // }).catch(error => {
    //     console.log("Invalid Start Recording without device :", error);
    // });
}

export const stopRecordingAPI = () => {
    const {
        usersData,
        roomorIpAddress,
        isHybridSession,
        devicesUsers
    } = getStore(FEATURE_CUSTOM_REDUX);
    let url = Constant.App.ServerUrl + '/stop-audio-route?roomname=' + roomorIpAddress + "&processtype=recording"
    if ((devicesUsers || usersData) && !isHybridSession) {
        // if(this._ValidateIPaddress(recIpAddress) && usersData) {
        axios.get(url).then(response => {
            if (response.data.status) {
                console.log("STOP Recording :", response);
                // let obj = {
                //     recordingip: recIpAddress,
                //     recordingkey: recTimeStamp,
                //     recordingUniqueID: uniqueId
                // };

                // console.log("socker send ", obj)
                // socketEmit("stop_recording", obj);
            } else {
                return false;
            }
        }).catch(error => {
            console.log("stop-audio-route error =>", error);
        });
    }
}



